export { default } from './StarHalfOutline'
